import styled from 'styled-components';

export const ButtonWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  pointer-events: auto;
  align-items: center;
  opacity: ${(props): string => (props.disabled ? '0.5' : '1')};
`;
